import {
    GET_MERCHANT_TRANSACTIONS_FAILED , 
    GET_MERCHANT_TRANSACTIONS_LOADING,
    GET_MERCHANT_TRANSACTIONS_SUCCESS , 
    REMOVE_MERCHANT_TRANSACTIONS 
  } from "../types";
  
  
const initialState = {
    transactions: null,
    loading: null,
    error: null,
  };
  
  export const getMerchntTransactionsReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_MERCHANT_TRANSACTIONS_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_MERCHANT_TRANSACTIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          transactions: action.payload,
        };
      case GET_MERCHANT_TRANSACTIONS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
        };
      case REMOVE_MERCHANT_TRANSACTIONS:
        return initialState;
      default:
        return state;
    }
  };
  